import { Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, Box, 
  Typography} from "@mui/material";
import { Stack } from "@mui/system";

const PRIVACY_NOTICE = [
`When you engage with the Space and Astronomy \
Compact Array Observatories through this Scheduler, \
CSIRO may collect certain personal information about \
you. When it does, your personal information is \
protected by the Privacy Act 1988 (Cth) (Privacy Act). \
CSIRO will handle your information in accordance with \
this Act as otherwise required by law.`,

`The only personal information this application collects \
is your email address which is used for authentication.`,

`All personal information are stored on \
secure AWS servers located in Australia, with \
strictly controlled access to the databases for \
those CSIRO officers with a 'need to know'.`,

`For further information on how CSIRO handles your \
personal information and our access, correction and \
complaints process please read our privacy policy \
available on our website \
(https://www.csiro.au/en/about/policies/privacy) \
or by contacting us at privacy@csiro.au.`
]

export default function PrivacyNoticeDialog(
  props: {
    open: boolean,
    handleClose: () => void,
  }
) {  
  const handleClose = () => {
    props.handleClose();
  }

  return (
    <Dialog open={props.open}
      aria-labelledby="privacy-notice-dialog-title"
      onClose={handleClose}
      maxWidth="md" fullWidth>
      <DialogTitle id="privacy-notice-dialog-title">
        Privacy Notice
      </DialogTitle>
      <DialogContent sx={{height: '100%'}}>
        <Stack spacing={3} sx={{ height: '100%' }}>

          {PRIVACY_NOTICE.map(
            (line, index) => (
              <Typography variant="body2" gutterBottom key={'privacy-notice-' + index}>
                {line}
              </Typography>
          ))}

        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
